export default {
  en: {
    uploaded: 'Uploaded',
  },
};
